export const DEV_WEB_SERVICE_URL = 'https://dev.cmhinfo.biz/WebServices3'; 
export const LEAD_API_ENDPOINT = 'leads';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyB6AeGdWo-bwqqklp6kLGcOENfl3waZzYo';